import { motion, useScroll, useTransform } from 'framer-motion';
import { useRef } from 'react';
import { Reveal, SectionLabel } from './Reveal';
import { IMAGES } from '../../data/content';

const chapters = [
  {
    no: '01',
    title: 'A special-purpose vehicle',
    text: 'London Biotech International is a UK-registered SPV — a dedicated entity established to ring-fence, govern and deliver defined infrastructure mandates with clarity and accountability.',
  },
  {
    no: '02',
    title: 'Convening rare expertise',
    text: 'We unite masterplanners, legal architects and healthcare consultants under one mandate, ensuring every discipline speaks the same language of delivery.',
  },
  {
    no: '03',
    title: 'Built for global mandates',
    text: 'From London to emerging health economies, our structure is designed to operate across borders, jurisdictions and public-sector frameworks.',
  },
];

export const About = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ['start end', 'end start'],
  });
  const y = useTransform(scrollYProgress, [0, 1], ['-8%', '8%']);

  return (
    <section
      id="about"
      ref={ref}
      data-testid="about-section"
      className="relative border-t border-white/5 bg-navy-900 py-24 lg:py-32"
    >
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <div className="grid grid-cols-1 gap-16 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-5">
            <Reveal>
              <SectionLabel>About Us</SectionLabel>
              <h2 className="mt-6 font-serif text-4xl leading-tight tracking-tight text-white sm:text-5xl">
                An institution engineered for delivery.
              </h2>
            </Reveal>
            <div className="mt-10 overflow-hidden">
              <motion.img
                style={{ y }}
                src={IMAGES.architecture}
                alt="Institutional architecture"
                className="aspect-[4/5] w-full scale-110 object-cover grayscale transition-all duration-700 hover:grayscale-0"
              />
            </div>
          </div>

          <div className="lg:col-span-6 lg:col-start-7">
            <div className="flex flex-col">
              {chapters.map((c, i) => (
                <Reveal key={c.no} delay={i * 0.08}>
                  <div className="border-t border-white/10 py-8 first:border-t-0 first:pt-0">
                    <div className="flex items-start gap-6">
                      <span className="font-serif text-3xl text-gold/70">
                        {c.no}
                      </span>
                      <div>
                        <h3 className="font-serif text-2xl tracking-tight text-white">
                          {c.title}
                        </h3>
                        <p className="mt-3 text-base leading-relaxed text-slate-300">
                          {c.text}
                        </p>
                      </div>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
